import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import light from '@advisor/plugins/theme';

const opts = {
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    dark: false,
    themes: {
      light,
    },
  },
};

Vue.use(Vuetify);

export default new Vuetify(opts);
